<template>
    <v-dialog
        persistent
        :max-width="getMaxWidth"
        v-model="openCommunicate"
        v-if="!isRead()"
    >
        <v-card
            style="border-radius: 10px !important"
            flat
            tile
            :max-width="getMaxWidth"
        >
            <v-window v-model="onboarding" reverse max-width="1200px">
                <!-- <v-window-item class="pa-4">
                    <PunchInClock />
                </v-window-item> -->
                <v-window-item v-if="checkCommunicate">
                    <CommercialCommunicate :elevationProp="0" class="ml-4" />
                </v-window-item>
                <v-window-item
                    v-if="numAgendados && numAgendados > 0 && !isRead()"
                >
                    <Scheduled :elevationProp="0" />
                </v-window-item>
            </v-window>

            <v-card-actions class="justify-space-between">
                <div class="d-flex flex-column mt-n5" style="width: 100%">
                    <div class="d-flex flex-row justify-space-between">
                        <v-btn text fab @click="prev">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-item-group
                            v-model="onboarding"
                            class="text-center"
                            mandatory
                        >
                            <v-item
                                v-for="n in length"
                                :key="`btn-${n}`"
                                v-slot="{ active, toggle }"
                            >
                                <v-btn
                                    :input-value="active"
                                    icon
                                    @click="toggle"
                                >
                                    <v-icon :color="active ? 'success' : ''"
                                        >mdi-record</v-icon
                                    >
                                </v-btn>
                            </v-item>
                        </v-item-group>
                        <v-btn text fab @click="next">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                    <div class="d-flex justify-end">
                        <v-btn
                            @click="
                                openCommunicate = false;
                                setRead();
                            "
                            text
                            color="red"
                        >
                            cerrar
                        </v-btn>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Scheduled from '@/components/DashBoard/DashBoardScheduled.vue';
import CommercialCommunicate from '@/components/CommercialCommunicate/CommercialCommunicate.vue';
import PunchInClock from '@/components/PunchIn/PunchInClock.vue'

import { mapState } from 'vuex';

export default {
    name: 'PopUpDialog',
    data: () => ({
        openCommunicate: false,
        length: 2,
        onboarding: 0,
    }),
    components: {
        Scheduled,
        CommercialCommunicate,
        PunchInClock
    },
    methods: {
        next() {
            this.onboarding =
                this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
        },
        prev() {
            this.onboarding =
                this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
        },
        communicates() {
            return JSON.parse(localStorage.getItem('communicates'));
        },
        meta() {
            return JSON.parse(localStorage.getItem('meta'));
        },
        isRead() {
            let meta = this.meta();
            return meta?.readCommunicates;
        },
        checkCommunicate() {
            let communicates = this.communicates();
            let meta = this.meta();

            let accountFilter = (receiver) =>
                receiver.account.id == this.cuenta.id;
            let isRead = (receiver) => !receiver.isRead;

            return (
                !meta?.readCommunicates &&
                communicates &&
                communicates.some(
                    (communicate) => communicate.priority == 'HIGH'
                ) &&
                communicates.some((communicate) =>
                    communicate.readReceivers.some(
                        (receiver) =>
                            accountFilter(receiver) && isRead(receiver)
                    )
                )
            );
        },
        setRead() {
            let meta = this.meta();
            meta.readCommunicates = true;
            localStorage.setItem('meta', JSON.stringify(meta));
        },
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        getMaxWidth(){
            return '600px'
        },
        ...mapState('dashboard', {
            numAgendados: (state) =>
                state.estadisticaAgendados.agendados.length,
        }),
    },
    watch: {
        numAgendados: {
            handler() {
                let windowLength = 0;

                if (!isNaN(this.numAgendados) && this.numAgendados > 0)
                    windowLength++;

                if (this.checkCommunicate()) windowLength++;

                if (windowLength == 0) this.openCommunicate = false;
                else this.openCommunicate = true;

                this.length = windowLength;
            },
            immediate: true,
        },
    },
};
</script>
